import { Component } from '@angular/core';

@Component({
    selector: 'app-dadosparticipante',
    templateUrl: './dadosparticipante.component.html',
    styleUrls: ['./dadosparticipante.component.scss']
  })
  export class dadosparticipanteComponent {}